<template>
  <div>
    <div
      v-if="abstract.confirmed === false && abstract.status_id === 3 && submissions.isConfirmationOpen === true">
      <div class="col d-flex my-auto">
        <router-link tag="button"
                     :to="'abstract/' + abstract.id + '/confirm/'"
                     class="btn btn-link mx-auto text-danger">
          <icon :icon="['fad', 'calendar-exclamation']" class="fa-2x"/>
          <br>
          Change
        </router-link>
      </div>
    </div>
    <div
      v-else-if="abstract.confirmed === true && abstract.status_id === 3 && submissions.isConfirmationOpen === true">
      <div class="col d-flex my-auto">
        <router-link tag="button"
                     :to="'abstract/' + abstract.id + '/confirm/'"
                     class="btn btn-link mx-auto text-success">
          <icon :icon="['fad', 'calendar-check']" class="fa-2x"/>
          <br>
          Changed
        </router-link>
      </div>
    </div>
    <div v-else>
      <div class="col-3 my-auto">
        <button class="btn btn-link disabled"
                v-if="abstract.confirmed === false && submissions.isConfirmationOpen === false">
          <icon :icon="['fad', 'calendar-exclamation']" class="fa-2x"/>
          <br>
          Confirm
        </button>
        <button class="btn btn-link disabled"
                v-else-if="abstract.confirmed === true && submissions.isConfirmationOpen === false">
          <icon :icon="['fad', 'calendar-check']" class="fa-2x"/>
          <br>
          Confirm
        </button>
        <button class="btn text-success pointer-no"
                v-else-if="abstract.confirmed === true && submissions.isConfirmationOpen === true">
          <icon :icon="['fad', 'calendar-check']" class="fa-2x"/>
          <br>
          Confirm
        </button>
        <button class="btn text-success pointer-no"
                v-else-if="abstract.confirmed === true && submissions.isConfirmationOpen === true">
          <icon :icon="['fad', 'calendar-check']" class="fa-2x"/>
          <br>
          Confirm
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'TableConfirmArea',
    props: {
      abstract: {},
      submission_id: {},
      submissions: {}
    }
  }
</script>
<style scoped>
  @media (min-width: 10em) {
  }
</style>
